import React, { useState } from 'react';
import { FormControl, MenuItem, Select, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { AdminDataGrid } from '@/admin/shared/AdminDataGrid';
import { useGetUserImportQuery } from '../../../api/userImportsApi';
import { userImportResultColumns } from './columns';
import { USER_IMPORT_ROW_STATUSES } from './UserImportRowStatusChip';

const ALL = 'all';

/**
 * Each row of a user import with its result (created, skipped or failed) and reason, as it
 * runs, from the cached getUserImport. All rows to start; the Result select above shows one
 * result (each option with its count). Clicking a created row opens that user.
 */
export const UserImportResultsTable = ({ importId }) => {
	const navigate = useNavigate();
	const { data: userImport } = useGetUserImportQuery(importId);
	const [result, setResult] = useState(ALL);
	const rows =
		result === ALL
			? userImport.rows
			: userImport.rows.filter(({ status }) => status === result);

	return (
		<Stack spacing={1}>
			<FormControl sx={{ width: 220 }}>
				<Select value={result} onChange={(event) => setResult(event.target.value)}>
					<MenuItem value={ALL}>{`All (${userImport.rows.length})`}</MenuItem>
					{Object.entries(USER_IMPORT_ROW_STATUSES).map(([status, { label }]) => (
						<MenuItem key={status} value={status}>
							{`${label} (${userImport[`${status}Count`]})`}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<AdminDataGrid
				table='userImportResults'
				columns={userImportResultColumns}
				rows={rows}
				getRowId={(row) => row.rowNumber}
				objectType='rows'
				// One height whatever the Result select shows, and as rows arrive while it runs
				height='50vh'
				maxHeight='50vh'
				showToolbar={false}
				initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
				// Only created rows have a user to open
				isRowClickable={(row) => Boolean(row.userId)}
				onRowClick={({ row }) =>
					row.userId && navigate(`${paths.admin}/users/${row.userId}`)
				}
			/>
		</Stack>
	);
};
